import { createTheme } from '@mui/material/styles';

const primaryColor = "#0a66c2";
const selectedHoverColor = "#4aa6f2";

const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor, // Customize your primary color
      text: "white"
    },
    sub:{
      main: "#bdd7dc",
      hover: "#86b7c2",
      text: "black"
    },
    secondary: {
      main: '#9c27b0', // Customize your secondary color
    }
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif', // Customize your font
  },
  components: {
    MuiButton:{
      styleOverrides:{
        root:{
          borderRadius: '100px', // Rounded corners
          textTransform: 'none',
        }
      }
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: '10px',
        },
        grouped:{
          borderRadius: '100px', // Rounded corners
          whiteSpace: 'nowrap', // Prevent text from wrapping
          border: '1px solid rgba(0, 0, 0, 0.12)', // Border for all buttons
          margin: '0', // Remove margin between buttons (to avoid border clash)
          padding: '5px', // Padding inside buttons
          textTransform: 'none',
          boxSizing: 'border-box', // Ensure border doesn't affect sizing
          '&:not(:first-of-type), &:not(:last-of-type)': {
            borderRadius: '100px', // Rounded corners
            whiteSpace: 'nowrap', // Prevent text from wrapping
            border: '1px solid rgba(0, 0, 0, 0.12)', // Border for all buttons
            margin: '0', // Remove margin between buttons (to avoid border clash)
            padding: '5px', // Padding inside buttons
            textTransform: 'none',
            boxSizing: 'border-box', // Ensure border doesn't affect sizing
          }
        }
      },
    },
    MuiToggleButton:{
      styleOverrides:{
        root:{
          borderRadius: '100px', // Rounded corners
          whiteSpace: 'nowrap', // Prevent text from wrapping
          border: '1px solid rgba(0, 0, 0, 0.12)', // Border for all buttons
          margin: '0', // Remove margin between buttons (to avoid border clash)
          padding: '5px', // Padding inside buttons
          textTransform: 'none',
          boxSizing: 'border-box', // Ensure border doesn't affect sizing
          '&.Mui-selected, &:active': {
            backgroundColor: primaryColor, // Selected button color
            color: 'white', // Text color of selected button
          },
          '@media (hover: hover) and (pointer: fine)': {
            '&:hover': {
            backgroundColor: selectedHoverColor, // Selected button color
            color: 'white', // Text color of selected button
          }},
          '&.Mui-selected:hover': {
            backgroundColor: primaryColor, // Selected button color
            color: 'white', // Text color of selected button
          },
          '& .MuiToggleButton-label': {
            padding: '0 10px', // Add padding around the text inside the button
          },
        }
      }
    },
    MuiToolbar:{
      styleOverrides: {
        root: {
          minHeight: '64px',
        }
      }
    },
    MuiContainer:{
      styleOverrides:{
        root:{
          borderRadius: '10px',
          boxShadow: 'black',
          padding: '2px',
          margin: '1px',
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
          },
        },
      },
    }
  }
});

export default theme;